// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'IModalActions' is declared but its value is never... Remove this comment to see the full error message
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { IModalActions } from "hooks/use-modal";

// Based on https://medium.com/@martin_hotell/improved-redux-type-safety-with-typescript-2-8-2c11a8062575

export interface IAction<T extends string = string> {
  type: T;
}

export interface IActionWithPayload<T extends string, P> extends IAction<T> {
  payload: P;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type FunctionType = (...args: any[]) => any;
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/naming-convention
interface ActionCreatorsMapObject {
  [actionCreator: string]: FunctionType;
}

export type ActionsUnion<A extends ActionCreatorsMapObject> = ReturnType<A[keyof A]>;

// function overloading
function actionCreator<T extends string>(type: T): IAction<T>;
function actionCreator<T extends string, P>(type: T, payload: P): IActionWithPayload<T, P>;
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function actionCreator<T extends string, P>(type: T, payload?: P) {
  return payload === undefined ? { type } : { type, payload };
}

export const createAction = actionCreator;

/**
 * Returning request action name based on action payload.
 * @param requestName Base request action name.
 * @param payload Action payload.
 */
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export const getRequestActionName = (requestName: any, payload: any) => {
  let requestActionName = requestName;
  if (payload.additionalRequestId) {
    requestActionName = `${requestActionName}_${payload.additionalRequestId}`;
  }
  return requestActionName;
};
